// Bibliotecas
import React from 'react';
import WhatsappMessage from './../useful/WhatsappMessage';
import toPriceValue from './../useful/formatter';

// Componentes
import Detail from './../Detail/Detail';
import Product from './../Product/Product';
import Cart from './../Cart/Cart';
import Bag from './../Bag/Bag';
import Welcome from './../Welcome/Welcome';
import DB from '../global/DB/DB';
import EndOrder from '../EndOrder/EndOrder';
import Logo from  './../../img/logo.svg';

import './App.css'; // CSS

export default class App extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            store: {
                products: DB().getProducts()
            },

            cart: {
                products: [],
                lastId: 0,
                show: false,
                showCreditCardMessage: false,
                paymentOptions: [
                    {id: 0, name: "PIX", mark: false},
                    {id: 1, name: "Débito", mark: false},
                    {id: 2, name: "Cartão de crédito", mark: false},
                    {id: 3, name: "Dinheiro", mark: false}
                ]
            },

            productDetail: {
                productId: null,
                productTop: null
            },

            welcome: {
                show: this.getWelcomeShow(),
                howToBuy: false
            },

            bagAnimation: false,
            endOrder: false,
            bag: true
        };

        window.addEventListener("scroll", this.hideBag);
    }

    hideBag = () => {
        if(window.scrollY + window.innerHeight >= document.body.offsetHeight - 60){
            this.setState({bag: false});
        }else this.setState({bag: true});
    }

    getWelcomeShow = () => {
        if(localStorage.getItem("welcome")) return false;

        localStorage.setItem("welcome", "true");
        return true;
    }

    makeBagAnimation = () => {
        this.setState({bagAnimation: true});

        setTimeout(() => {
            this.setState({bagAnimation: false});
        }, 1400)
    }

    markPaymentOption = (id) => {
        this.setState(state => {
            state.cart.paymentOptions.map(option => {
                option.mark = option.id == id? true : false;
                return option;
            });

            state.cart.showCreditCardMessage = id == 2? true : false;
            
            return state;
        });
    }

    sendOrder = () => {
        const {products, paymentOptions} = this.state.cart;
        const messager = WhatsappMessage("5511943450270");
        const paymentOptionMarked = paymentOptions.find(option => option.mark == true);
        const totals = this.getTotals(products);

        messager.write("Olá, meu pedido é:", 2);
        
        products.forEach(product => {
            const unityPrice = Object.keys(product.options).reduce((total, optName) => {
                const markedOpt = product.options[optName].values.find(opt => opt.mark == true);
                const hasMarkedOption = markedOpt != undefined;

                if(!hasMarkedOption)
                    return total;
                
                return total + (markedOpt.price || 0);
            }, 0);

            messager.write(`*${product.quantity} - ${product.name}*`);

            DB().getProductMarkedOptions(product.options).forEach(option => {
                messager.write(`${option.optionText} - ${option.markedOption.value}`, 1);
            });
            
            messager.write(`Total - R$ ${toPriceValue(unityPrice * product.quantity)}`, 1);
            messager.write("", 1);
        });

        messager.write(`Total de itens - ${totals.quantity}`, 1);
        messager.write(`Total da compra - R$ ${toPriceValue(totals.price)}`, 2);
        messager.write("*Forma de pagamento*", 1);
        messager.write(paymentOptionMarked.name, 1);
        
        messager.send();

        this.hideEndOrder();
    };

    getTotals = (products) => {
        let price = 0;
        let quantity = 0;

        products.forEach(product => {
            const unityPrice = Object.keys(product.options).reduce((total, optName) => {
                const markedOpt = product.options[optName]?.values.find(opt => opt.mark == true);
                const hasMarkedOption = markedOpt != undefined;

                if(!hasMarkedOption)
                    return total;

                return total + (markedOpt.price || 0);
            }, 0);

            price += unityPrice * product.quantity;
            quantity += product.quantity;
        });
        
        return {price, quantity};
    }

    addToCart = (product) => {
        const cart = this.state.cart;
        const newProduct = JSON.parse(JSON.stringify(product));

        newProduct.id = cart.lastId;
        cart.lastId ++;

        cart.products = [...cart.products, newProduct];

        this.setState({cart}, this.makeBagAnimation);
    };

    removeOfCart = (productId) => {
        this.setState(state => {
            state.cart.products = state.cart.products.filter(product => (
                product.id != productId
            ));
            
            return state;
        });
    };

    editOnCart = (productId, newProduct) => {
        this.setState(state => {
            state.cart.products.map(product => product.id == productId? newProduct : product);
            return state;
        });
    }

    increaseQuantityOnCart = (productId) => {
        this.setState(state => {
            state.cart.products.map(product => {
                if(product.id == productId) product.quantity++;
                return product;
            });
            
            return state;
        });
    };

    decreaseQuantityOnCart = (productId) => {
        this.setState(state => {
            state.cart.products.map(product => {
                if(product.id == productId && (product.quantity - 1) > 0) product.quantity--;
                return product;
            });
            
            return state;
        });
    }

    showCart = () => {
        this.setState(s => {
            s.cart.show = true;
            return s;
        });

        this.pageScroll(false);
    };

    hideCart = () => {
        this.setState(s => {
            s.cart.show = false;
            return s;
        });

        this.pageScroll(true);
    };

    showProductDetail = (productId, productNode) => {
        const productTop = window.innerHeight - ((productNode.offsetTop + productNode.offsetHeight) - window.scrollY);
        
        this.setState({
            productDetail: {productId, productTop}
        });

        this.pageScroll(false);
    }

    hideProductDetail = () => {
        this.setState({productDetail: {productId: null}});
        this.pageScroll(true);
    }

    hideWelcome = () => {
        this.setState(state => ({
            welcome: {show: false, howToBuy: state.welcome.howToBuy}
        }));

        this.pageScroll(true);
    }

    showWelcome = (howToBuy) => {
        this.setState({
            welcome: {show: true, howToBuy}
        });

        this.pageScroll(false);
    }

    endOrder = () => {
        this.showEndOrder();
    }
    
    showEndOrder = () => {
        this.setState({endOrder: true});
    }

    hideEndOrder = () => {
        this.setState({endOrder: false});
    }

    pageScroll = (value) => {
        document.body.style.overflow = value == true? "" : "hidden";
    }

    render(){
        const {productDetail, welcome, endOrder, bag, bagAnimation} = this.state;
        const products = this.state.store.products;
        const cart = this.state.cart;
        const {showCreditCardMessage} = cart;

        return (
            <div className="app">
                {welcome.show? (
                    <Welcome
                        howToBuy={welcome.howToBuy}
                        onClose={this.hideWelcome} />
                ) : ""}

                <header className="header">
                    <div className="header__content max-width">
                        <img className="header__logo-img" src={Logo} />

                        <span className="header__button" onClick={() => this.showWelcome(true)}>
                            Como comprar
                        </span>
                    </div>
                </header>
                
                <div className="app__content max-width">
                    <div className="app__products">
                        {products.map(product => (
                            <Product
                                id={product.id}
                                name={product.name}
                                weights={product.options.weights.values}
                                showPlus={true}
                                cursorPointer={true}
                                key={product.id}
                                onClick={this.showProductDetail} />
                        ))}
                    </div>
                </div>

                {productDetail.productId != null? (
                    <Detail
                        product={products.find(product => product.id == productDetail.productId)}
                        productTop={productDetail.productTop}
                        onClose={this.hideProductDetail}
                        onAddToCart={this.addToCart} />
                ) : ""}

                <Bag
                    onClick={this.showCart}
                    quantity={cart.products.length}
                    animation={bagAnimation}
                    visibility={bag} />

                {endOrder? (
                    <EndOrder
                        onSucesss={this.sendOrder}
                        onClose={this.hideEndOrder} />
                ) : ""}

                <Cart
                    cart={cart}
                    showCreditCardMessage={showCreditCardMessage}
                    getTotals={this.getTotals}
                    onMarkPaymentOption={this.markPaymentOption}
                    onClose={this.hideCart}
                    onRemoveProduct={this.removeOfCart}
                    onEditProduct={this.editOnCart}
                    onIncreaseProductQuantity={this.increaseQuantityOnCart}
                    onDecreaseProductQuantity={this.decreaseQuantityOnCart}
                    onEndOrder={this.endOrder} />
                
                <footer className="footer">
                    <div className="footer__item">
                        <span className="footer__label">Whatsapp</span>
                        <span className="footer__content">
                            <a href="https://api.whatsapp.com/send?phone=5511943450270&text=">(11) 94345-0270</a>
                        </span>
                    </div>
                    
                    <div className="footer__item">
                        <span className="footer__label">Desenvolvido por</span>
                        <span className="footer__content">
                            <a href="mailto:mateusfmorelli@hotmail.com">Mateus (mateusfmorelli@hotmail.com)</a>
                        </span>
                    </div>
                </footer>
            </div>
        );
    }
}